import React, { useEffect } from 'react';
import { Alert } from 'react-bootstrap';

const TimedAlert = ({show, onClose, duration = 3000, variant = 'success', message }) => {
    useEffect(() => {
        if (show) {
          const timer = setTimeout(() => {
            onClose();
          }, duration);
          return () => clearTimeout(timer);
        }
      }, [show, duration, onClose]);
    
      return (
        <Alert show={show} variant={variant} onClose={onClose} dismissible>
          {message}
        </Alert>
      );
}

export default TimedAlert;